module.exports = __webpack_public_path__ + "static/media/crdsciempty.ac542b8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/public/userarea/crdsciempty.png
// module id = 581
// module chunks = 0